<script>
  import { CirclePlus, CircleMinus } from 'lucide-svelte';
  import { slide } from 'svelte/transition';

  export let title = '';
  export let icon = '';
  export let highlight = false;
  export let openByDefault = false;

  let open = openByDefault;
</script>

<div class="">
  <div
    class="flex items-center cursor-pointer space-x-1 py-1"
    on:click={() => (open = !open)}
  >
    {#if icon}
      <span class="text-2xl leading-none">{icon}</span>
    {/if}

    {#if highlight}
      <span class="text-l px-1 rounded-sm bg-[var(--green)] text-black leading-none">
        {title}
      </span>
    {:else}
      <span class="text-base font-medium leading-none">
        {title}
      </span>
    {/if}

    <!-- Icon right after title -->
    {#if open}
      <CircleMinus strokeWidth={3} class="w-5 h-5 text-[var(--green)]" />
    {:else}
      <CirclePlus strokeWidth={3} class="w-5 h-5 text-[var(--green)]" />
    {/if}
  </div>

  {#if open}
    <div class="px-2 text-base py-1 leading-tight bg-[#f0f0f0] rounded-md mt-0" transition:slide>
      <slot />
    </div>
  {/if}
</div>

